<!-- Il dialog di attesa non ha azioni: niente titolo Material e niente fascia
     panna, solo il contenuto centrato dentro la superficie bordata che gli
     mette .izy-loading-dialog-panel (styles.scss). -->
<div class="izy-loading-dialog">
  <mat-progress-spinner
    class="izy-loading-spinner"
    diameter="52"
    mode="indeterminate">
  </mat-progress-spinner>

  <h2 class="izy-loading-title">Operazione in corso</h2>
  <p class="izy-loading-text">Stiamo completando l'operazione, attendi qualche istante.</p>
</div>
